const pricingData = [
  {
    title: "Personal",
    price: 59,
    description: "Best Choice For Individuals",
    isPopular: false,
    btnClass: "block w-full py-4 text-lg text-center btn text-purple border-purple hover:bg-purple hover:text-white"
  },
  {
    title: "Business",
    price: 89,
    description: "Best Choice For Priority Support",
    isPopular: false,
    btnClass: "block w-full py-4 text-lg text-center btn text-purple border-purple hover:bg-purple hover:text-white"
  },
  {
    title: "Enterprise",
    price: 99,
    description: "Explore select, our premium solution for businesses.",
    isPopular: true,
    btnClass: "btn bg-purple py-4 text-lg w-full block text-center border border-purple rounded text-white transition-all duration-300 hover:bg-purple/[0.85] hover:border-purple/[0.85]"
  },
];

export { pricingData };
